import { Chat } from "../../../../common/Chat";
import { useAppModals } from "../../../../app/state/modalSlice/hook/use-app-modals";
import { useAppSelector } from "../../../../services/redux/hooks/use-selector";
import { AttachedFileModal } from "../../../Modals/AttachedFileModal";
import { UPLOADED_FILE_EXTENSIONS } from "../../../Modals/AttachedFileModal/constants";
import { useDialogs } from "../../hooks/use-dialogs";
import { selectIsMessageLoading } from "../../redux/selectors";

export const DialogChat = () => {
  const {
    fileName,
    message,
    messages,
    isFileLoading,
    inputRef,
    handleClick,
    handleDeleteFileTag,
    handleFileUpload,
    handleChangeMessage,
    handleSendKeyDown,
    handleSendMessage,
  } = useDialogs();
  const isMessageLoading = useAppSelector(selectIsMessageLoading);
  const { handleOpenModal, handleCloseModal } = useAppModals();

  return (
    <>
      <Chat
        inputRef={inputRef}
        messages={messages}
        userMessage={message}
        isMessageLoading={isMessageLoading}
        handleSendMessage={handleSendMessage}
        handleKeyDownMessage={handleSendKeyDown}
        onChangeUserMessage={handleChangeMessage}
        handleFileUpload={handleFileUpload}
        handleOpenAttachedFileModal={handleOpenModal}
        onDeleteFilaTag={handleDeleteFileTag}
        fileName={fileName ?? ""}
        isFileLoading={isFileLoading}
        isResizable
      />
      <AttachedFileModal
        extensions={UPLOADED_FILE_EXTENSIONS}
        onClose={handleCloseModal}
        handleClick={handleClick}
        multiple={false}
      />
    </>
  );
};
